<!-- 联系我们 -->
<template>
  <div class="certificate-container">
    <div class="certificate-content">
        <div style="background-color: white;">
        <div class="title">相关证书</div>
        <div class="desc">领点回收已获得相关资质认证，请放心使用</div>
    </div>
      <!-- 营业执照 -->
      <div class="cert-section">
        <div class="cert-title">1. 国家企业信用信息系统</div>
        <div class="cert-image-container">
<!--          <img class="cert-image" src="@/assets/newImage/1.jpg"/>-->
          <img class="cert-image" src="@/assets/newImage/2.png"/>
        </div>
      </div>

      <!-- 公安备案 -->
      <div class="cert-section">
        <div class="cert-title">2. 公安备案号</div>
        <div class="cert-image-container">
<!--            <img class="cert-image" src="@/assets/newImage/xxx"/>-->
        </div>
      </div>

      <!-- 增值电信业务经营许可证 -->
      <div class="cert-section">
        <div class="cert-title">3. 增值电信业务经营许可证</div>
        <div class="cert-image-container">
            <img class="cert-image" src="@/assets/newImage/4.jpg"/>
        </div>
      </div>

      <!-- 计算机软著登记保护 -->
      <div class="cert-section">
        <div class="cert-title">4.计算机软著登记保护</div>
        <div class="cert-image-container">
            <img class="cert-image" src="@/assets/newImage/5.jpg"/>
<!--            <img class="cert-image" src="@/assets/newImage/6.jpg"/>-->
        </div>
      </div>

      <!-- 工信部备案信息 -->
      <div class="cert-section">
        <div class="cert-title">5.工业和信息化部政务服务平台</div>
        <div class="cert-image-container">
            <img class="cert-image" src="@/assets/newImage/7.png"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Certificate'
};
</script>

<style lang="scss" scoped>
.certificate-container {
  padding: 20px;
  max-height: 80vh;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;



  .certificate-content {
    .title {
    font-size: 24px;
    font-weight: 500;
    color: #333;
    margin-bottom: 10px;
    background: #fff;
    z-index: 1;
  }

  .desc {
    font-size: 14px;
    color: #666;
    margin-bottom: 30px;
    background: #fff;
    padding: 10px 0;
  }
    .cert-section {
      margin-bottom: 40px;

      .cert-title {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        margin-bottom: 20px;
      }

      .cert-image-container {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;

        .cert-image {
          width: 100%;
          max-width: 400px;
          height: auto;
          background-color: #f5f5f5;
          border-radius: 8px;
          margin-bottom: 20px;
        }
      }
    }
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f5f5;
  }
}
</style>
